import { z } from 'zod';
import { BaseFlowBlockEventDefinitionSchema } from './event.js';
import { FlowBlockType } from './type.js';
import { FlowProducedType } from '../../flowRun/producedType.js';
export const BaseFlowBlockUiDataSchema = z.object({
    position: z.object({
        x: z.number(),
        y: z.number(),
    }),
    groupNodeId: z.string().optional(),
    areExtraTargetHandlesVisible: z.boolean().optional(),
});
export function FlowBlockReturnTypeSchema(returnType) {
    return z
        .unknown()
        .optional()
        .transform(() => returnType);
}
/**
 * Strict base schema every block config schema extends. Unlike {@link FlowBlockSchema} (the loose
 * structural envelope), this fixes the shared fields with their full validation and defaults; each
 * block's config schema `.extend()`s it with a literal `type` and a concrete `config` shape.
 */
export const BaseFlowBlockSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().optional().default(''),
    uiData: BaseFlowBlockUiDataSchema,
    mockDataEnabled: z.boolean().optional(),
    mockData: z.unknown().optional(),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.Any),
    milestoneName: z.string().optional(),
    events: z.array(BaseFlowBlockEventDefinitionSchema).optional(),
    stats: z.record(z.string(), z.number()).optional(),
});
/**
 * Loose structural schema for a flow block. The `config` field is intentionally
 * opaque (`z.unknown()`) — this schema validates only the envelope shared by every
 * block. Strict per-type config validation lives in flow-api's `FlowBlockUnionSchema`
 * (a discriminated union over each block's config schema).
 */
export const FlowBlockSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    uiData: z.object({
        position: z.object({ x: z.number(), y: z.number() }),
        groupNodeId: z.string().optional(),
        areExtraTargetHandlesVisible: z.boolean().optional(),
    }),
    mockDataEnabled: z.boolean().optional(),
    mockData: z.unknown().optional(),
    returnType: z.enum(FlowProducedType).optional(),
    milestoneName: z.string().optional(),
    events: z.array(BaseFlowBlockEventDefinitionSchema).optional(),
    stats: z.record(z.string(), z.number()).optional(),
    type: z.enum(FlowBlockType),
    config: z.unknown(),
});
//# sourceMappingURL=block.js.map